import { NAMESPACES } from "@commerce-os/i18n";
import { useTranslation } from "react-i18next";

/**
 * `t` with every namespace loaded and typed: `t("actions.save")` (common) or `t("auth:signIn.title")`. A
 * misspelt key is a type error (packages/i18n).
 */
export function useT() {
  return useTranslation(NAMESPACES);
}

export type T = ReturnType<typeof useT>["t"];
